export default "/_next/static/images/christopher-rempel-575c1590a83d004c19e9df4ad2e5bd24.png";